// extracted by mini-css-extract-plugin
module.exports = {"starting":"AuthForm_starting__3Z1vv","auth":"AuthForm_auth__3wpCg","control":"AuthForm_control__3kg2s","actions":"AuthForm_actions__h-zkj","toggle":"AuthForm_toggle__2O1hp"};